var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 4,
    viewBox: "0 0 28 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91402 0.792389C1.2251 0.792389 0.666626 1.35087 0.666626 2.03978C0.666626 2.7287 1.2251 3.28717 1.91402 3.28717H8.59643V0.792389H1.91402ZM10.1073 0.792389H17.8288V3.28717H10.1073V0.792389ZM19.5584 0.792389H26.0859C26.7748 0.792389 27.3333 1.35087 27.3333 2.03978C27.3333 2.7287 26.7748 3.28717 26.0859 3.28717H19.5584V0.792389Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d387db74397c25de6762deee1bac84ad.svg";
export { ForwardRef as ReactComponent };